import { Route, Routes } from 'react-router-dom'

import { MainPage } from 'pages/avia'
import { AviaPages } from 'pages/avia/router'
import { BeketPages } from 'pages/beket/routes/routes'
import { CloseCircleRouter } from 'pages/close-circle/router'
import { ExcursionPages } from 'pages/excursions/routes/routes'
import { InsurancePages } from 'pages/insurance/router'
import { KyrgyzstanRouter } from 'pages/kyrgyzstan/router'
import Offers from 'pages/profile/pages/offers'
import { ToursPages } from 'pages/tours/routes/router'
import { UmrahPages } from 'pages/umrah/routes/router'

import { UserAvailable } from 'features/user-available'

import { DialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/ui'

import {
  DetailProfile,
  EditProfile,
  EsimPage,
  Feedback,
  Icons,
  MyOrdersArchivePage,
  MyOrdersPage,
  PaymentSuccess,
  Profile,
  PromoPage,
  TouraikaPage,
  ViewProfile,
} from './pages'
import { RoutingPaths } from './routes'

const Router = () => (
  <UserAvailable>
    <Routes>
      <Route
        path={RoutingPaths.promo.base()}
        element={<PromoPage />}
      />

      <Route
        path={`/${RoutingPaths.profileDetail.base()}`}
        element={<DetailProfile />}
      />

      <Route
        path={`/${RoutingPaths.profile.base()}`}
        element={<Profile />}
      />

      <Route
        path={`/${RoutingPaths.profile.edit.base()}`}
        element={<EditProfile />}
      />
      <Route
        path={`/${RoutingPaths.profile.view.base()}`}
        element={<ViewProfile />}
      />

      <Route
        path={`/${RoutingPaths.feedback.base()}`}
        element={<Feedback />}
      />

      <Route
        path={`/${RoutingPaths.offers.base()}`}
        element={<Offers />}
      />

      <Route
        path={`/${RoutingPaths.payment.base()}`}
        element={<PaymentSuccess />}
      />

      {/* My orders */}
      <Route
        path={`${RoutingPaths.myOrders.base()}`}
        element={<MyOrdersPage />}
      />

      <Route
        path={`${RoutingPaths.myOrders.baseArchive()}`}
        element={<MyOrdersArchivePage />}
      />

      {/* Excursions */}
      <Route
        path={`${RoutingPaths.excursion.base()}/*`}
        element={<ExcursionPages />}
      />

      {/* Beket */}
      <Route
        path={`${RoutingPaths.beket.base()}/*`}
        element={<BeketPages />}
      />

      {/* Kyrgyzstan */}
      <Route
        path={`${RoutingPaths.kyrgyzstan.base()}/*`}
        element={<KyrgyzstanRouter />}
      />

      {/* Tours */}
      <Route
        path={`${RoutingPaths.tours.base()}/*`}
        element={<ToursPages />}
      />

      {/* Umrah */}
      <Route
        path={`${RoutingPaths.umrah.base()}/*`}
        element={<UmrahPages />}
      />

      {/* Avia */}
      <Route
        path={`${RoutingPaths.path()}`}
        element={<MainPage />}
      />

      <Route
        path={`/${RoutingPaths.avia.base()}/*`}
        element={<AviaPages />}
      />

      {/* Close circle start */}
      <Route
        path={`${RoutingPaths.closeCircle.base()}/*`}
        element={<CloseCircleRouter />}
      />

      {/* Travel insurance */}
      <Route
        path={`${RoutingPaths.insurance.base()}/*`}
        element={<InsurancePages />}
      />

      <Route
        path={RoutingPaths.icons.base()}
        element={<Icons />}
      />

      <Route
        path={RoutingPaths.touraika.base()}
        element={<TouraikaPage />}
      />

      <Route
        path={RoutingPaths.touraika.detail.base()}
        element={<TouraikaPage />}
      />

      <Route
        path={RoutingPaths.esim.base()}
        element={<EsimPage />}
      />
    </Routes>

    <DialogBottomSheet />
  </UserAvailable>
)

export default Router
